import { Link } from '@tanstack/react-router';
import { IconPin, Logo } from '../components/icons';

export function NotFound() {
  return (
    <div className="loading-screen" style={{ padding: 24 }}>
      <div className="empty" style={{ maxWidth: 360 }}>
        <Logo size={44} />
        <span className="empty-mark" style={{ marginTop: 18 }}>
          <IconPin />
        </span>
        <h3>This page doesn’t exist</h3>
        <p>The link may be old, or the address has a typo.</p>
        <Link to="/" className="btn btn-dark" style={{ marginTop: 12 }}>
          Go to Live
        </Link>
      </div>
    </div>
  );
}
